<template>
  <div class="aha-loading-dots" :class="`aha-loading-dots--${size} aha-loading-dots--${variant}`" />
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    variant: {
      type: String,
      default: 'dark',
    },
  },
}
</script>

<style lang="scss">
.aha-loading-dots {
  aspect-ratio: 4;
  clip-path: inset(0 100% 0 0);
  animation: l1 1s steps(4) infinite;

  &.aha-loading-dots--sm {
    width: 13px;
    height: 13px;
  }

  &.aha-loading-dots--dark {
    background: radial-gradient(circle closest-side, #313131 90%, #0000) 0/calc(100%/3) 100% space;
    background-position: 0 0;
  }

  &.aha-loading-dots--light {
    background: radial-gradient(circle closest-side, #fff 90%, #0000) 0/calc(100%/3) 100% space;
    background-position: 0 0;
  }
}

@keyframes l1 {
  to {
    clip-path: inset(0 -34% 0 0)
  }
}
</style>
